import { BASEURL } from '@/utils/enums';
import { httpRequest } from '@/utils/umiRequest';
import { getGlobalConfigByModule } from '../configs';
import { EmailTickets } from './types/TicketsResponses';

/**
 * 获取邮件工单模块的配置
 * @param params
 * @param options
 * @param cancelable 可否取消
 * @returns
 */
export async function getEmailDisputeTicketConfig(
  options?: Record<string, any>,
  cancelable = false,
) {
  return await getGlobalConfigByModule('email-ticket', options, cancelable);
}

/**
 * 获取邮件工单列表
 * @param params
 * @param options
 * @returns
 */
export async function getEmailDisputeCardList(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.post<EmailTickets>(BASEURL.EMAIL_DISPUTE_TICKET, params, options);
}

/**
 * 获取邮件工单全局统计数据
 * @param params
 * @param options
 * @returns
 */
export async function getEmailGlobalStatistics(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.get<any>(
    `${BASEURL.EMAIL_DISPUTE_TICKET}/total-statics`,
    params,
    options,
  );
}

/**
 * 获取邮件工单个人统计数据
 * @param params
 * @param options
 * @returns
 */
export async function getEmailPersonalStatistics(options?: Record<string, any>) {
  return await httpRequest.get<any>(`${BASEURL.EMAIL_DISPUTE_TICKET}/my-statics`, {}, options);
}

/**
 * 邮件工单批量更新状态
 * @param params
 * @param options
 * @returns
 */
export async function updateEmailDisputeTicketsStatus(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.post<any>(`${BASEURL.EMAIL_DISPUTE_TICKET}/update`, params, options);
}

/**
 * 邮件工单单个更新状态
 * @param params
 * @param options
 * @returns
 */
export async function updateSingleEmailDisputeTicketsStatus(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.put<any>(
    `${BASEURL.EMAIL_DISPUTE_TICKET}/${params.id}`,
    { status: params.status },
    options,
  );
}

/**
 * 邮件工单批量关闭工单
 * @param params
 * @param options
 * @returns
 */
export async function closeEmailDisputeTickets(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.post<any>(`${BASEURL.EMAIL_DISPUTE_TICKET}/close`, params, options);
}

/**
 * 邮件工单指派客服（单个）
 * @param params
 * @param options
 * @returns
 */
export async function assignSingleEmailDisputeTickets(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.post<any>(
    `${BASEURL.EMAIL_DISPUTE_TICKET}/user-for-single`,
    params,
    options,
  );
}

/**
 * 邮件工单批量指派客服
 * @param params
 * @param options
 * @returns
 */
export async function assignEmailDisputeTickets(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.post<any>(`${BASEURL.EMAIL_DISPUTE_TICKET}/user`, params, options);
}

/**
 * 邮件工单创建标签
 * @param params
 * @param options
 * @returns
 */
export async function createEmailDisputeTicketTag(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.post<any>(`${BASEURL.EMAIL_DISPUTE_TICKET}/tag`, params, options);
}

/** 获取邮件详情 */
export async function fetchEmaillDetail(id = '', options?: Record<string, any>) {
  return httpRequest.cancelable.get(`/email-ticket/${id}`, {}, options);
  // 脏数据兼容，如果 res.order_info 不是数组则返回空数组
  // if (res && !Array.isArray(res.order_info)) {
  //   res.order_info = [];
  // }
  // return res;
}

/** 获取邮件内容 */
export async function fetchEmaillJson(url = '', options?: Record<string, any>) {
  return httpRequest.get(
    url,
    {},
    { ...options, skipErrorHandler: true, skipResponseInterceptor: true },
  );
}

/** 获取邮件个人统计 */
export function fetchEmailMyStatics(options?: Record<string, any>) {
  return httpRequest.cancelable.get(`/email-ticket/my-statics`, {}, options);
}

/** 更新单笔工单 */
export async function updateEmailTicket(id: string, data: any, options?: Record<string, any>) {
  return httpRequest.put(`/email-ticket/${id}`, data, options);
}

/** 更新单笔工单的邮件 */
export async function updateEmailTicketMail(id: string, data: any, options?: Record<string, any>) {
  return httpRequest.put(`/set-email/${id}`, data, options);
}

// 客服回复邮件
export async function replyEmailTicket(id: string, data: any, options?: Record<string, any>) {
  return httpRequest.post(`/email-ticket/${id}/reply`, data, options);
}

// 邮件撤回
export async function revokeEmail(
  ticketId: number,
  emailId: number,
  options?: Record<string, any>,
) {
  return httpRequest.put(`/email-ticket/${ticketId}/email/${emailId}/revoke`, {}, options);
}

// 邮件重发
export async function retryEmail(ticketId: number, emailId: number, options?: Record<string, any>) {
  return httpRequest.put(`/email-ticket/${ticketId}/email/${emailId}/retry`, {}, options);
}

// 添加邮件备注
export async function reMarkEmail(
  ticketId: number | string,
  data: Record<string, any>,
  options?: Record<string, any>,
) {
  return httpRequest.post(`/email-ticket/remark/${ticketId}`, data, options);
}

// 编辑邮件备注
export async function editReMarkEmail(
  ticketId: number | string,
  remarkId: number | string,
  data: Record<string, any>,
  options?: Record<string, any>,
) {
  return httpRequest.post(`/email-ticket/${ticketId}/remark/${remarkId}`, data, options);
}

// 删除邮件备注
export async function delReMarkEmail(
  ticketId: number | string,
  remarkId: number | string,
  options?: Record<string, any>,
) {
  return httpRequest.delete(`/email-ticket/${ticketId}/remark/${remarkId}`, {}, options);
}

//
export async function saveEmailTranslate(
  email_id: number,
  data: any,
  options?: Record<string, any>,
) {
  return httpRequest.post(`email-ticket/email/${email_id}`, data, options);
}

/** 获取邮件个人统计 */
export async function fetchEmailTimeLine(
  email: string,
  page: number,
  pageSize: number,
  options?: Record<string, any>,
) {
  return httpRequest.get(
    `/email-ticket/record/${email}`,
    {
      page,
      per_page: pageSize,
    },
    options,
  );
}

// 效验订单编号
export async function checkOrderNumber(orderNumber: string, options?: Record<string, any>) {
  return httpRequest.get(`/lfd/check/order/${encodeURIComponent(orderNumber)}`, {}, options);
}

// 获取智能推荐列表数据
export async function getIntelligentReplyListData(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.post<any>(`/chat/qdeskemails/recommendations`, params, {
    ...options,
    headers: {
      isRecommendations: true,
    },
  });
}

// 新增推荐
export async function createRecommendations(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.post<any>(`chat/qdeskemails/recommendations/store`, params, options);
}

// 上传采纳信息
export async function updateAdoptionInfo(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.post<any>(`/chat/qdeskemails/adoption-record/store`, params, options);
}

// 变更采纳状态，更新不采纳原因
export async function changeRecommendations(
  params: Record<string, any>,
  options?: Record<string, any>,
) {
  return await httpRequest.put<any>(
    // `/saas-dispute/change-adoption/${params.id}`,
    `/saas-dispute/${params.id}`,
    { is_adoption: params.status, adoption_reason: params.reason },
    options,
  );
}

// 提供需要预翻译的数据给后端
export async function preTranslate(params: Record<string, any>, options?: Record<string, any>) {
  return await httpRequest.post<any>('/email-ticket/email/pre-translate', params, options);
}

// 获取订单中心补充字段
export function orderCenterExtraField(id: string) {
  return httpRequest.get(`/email-ticket/order-center/detail/${encodeURIComponent(id)}`);
}

// 获取订单中心补充字段(可取消)
export function orderCenterExtraFieldCancelable(id: string) {
  return httpRequest.cancelable.get(`/email-ticket/order-center/detail/${encodeURIComponent(id)}`);
}

// Saas获取订单中心补充字段(可取消)
export function orderSaasCenterExtraFieldCancelable(id: string) {
  return httpRequest.cancelable.get(`/saas-dispute/order-center/detail/${id}`);
}

// 获取订单中心列表
export async function orderCenterList(params: Record<string, any>, options?: Record<string, any>) {
  return httpRequest.post(`/email-ticket/order-center`, params, options);
}

// 获取AI总结
export async function getEmailSummary(params: Record<string, any>, options?: Record<string, any>) {
  return httpRequest.post(`/email-ticket/ai-summary`, params, options);
}

// 提供需要预总结的数据给后端
export async function preSummary(params: Record<string, any>, options?: Record<string, any>) {
  return await httpRequest.post<any>('/email-ticket/pre-summary', params, options);
}